import { render } from "./TuiKuanList.vue?vue&type=template&id=41651b6c&scoped=true"
import script from "./TuiKuanList.vue?vue&type=script&lang=js"
export * from "./TuiKuanList.vue?vue&type=script&lang=js"

import "./TuiKuanList.vue?vue&type=style&index=0&id=41651b6c&lang=less&scoped=true"

import exportComponent from "D:\\fxwl\\wx-wl_full\\wx-wl_full\\fxwl\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41651b6c"]])

export default __exports__